import uniq from "lodash/uniq";
import { isFunction } from "views/logic/aggregationbuilder/Series";
import fieldTypeFor from "views/logic/fieldtypes/FieldTypeFor";
export const selectableFieldsFor = (rowFieldNames, types, interactive) => interactive ? rowFieldNames.filter((field) => !isFunction(field) && !fieldTypeFor(field, types).isDecorated()) : [];
const queryValueFor = (row, field) => {
  const value = row[field];
  return typeof value === "string" || typeof value === "number" ? value : void 0;
};
export const rowSelectionKey = (row, rowFieldNames) => JSON.stringify(rowFieldNames.map((field) => row[field]));
export const rowSelectionLabel = (row, rowFieldNames) => `Select ${rowFieldNames.map((field) => `${field} ${row[field]}`).join(", ")}`;
export const selectedValuesByField = (rows, rowFieldNames, selectableFields, selectedKeys, types) => {
  const selectedRows = rows.filter((row) => selectedKeys.includes(rowSelectionKey(row, rowFieldNames)));
  return selectableFields.map((field) => ({
    field,
    type: fieldTypeFor(field, types),
    values: uniq(selectedRows.map((row) => queryValueFor(row, field)).filter((value) => value !== void 0))
  }));
};
